<template>
  <div class="creation-demand-step-qualification">
    <h2 class="step-title">
      {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@QUALIFICATIONS_TITLE")) }}
    </h2>
    <div v-if="familiesOptions.length > 0" class="creation-family-qualification">
      <ExtraMultiBtn v-model="familyId" :options="familiesOptions" @click="setQualifications" />
      <section v-if="familyId">
        <h2 class="step-title">
          {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.DEMANDS.CREATION.@QUALIFICATIONS_SUBTITLE")) }}
        </h2>
        <ExtraRoundedBtn
          v-for="qualification in qualifications"
          :key="qualification.getId()"
          :label="qualification.getName()"
          :hide="!showAll && !qualification.isFavorite() && !isActive(qualification)"
          :active="isActive(qualification)"
          @click.once="selectQualification(qualification)"
        />
        <QBtn
          v-show="!showAll && hiddenQualifications.length > 0"
          color="secondary"
          class="full-width"
          :label="$t('ETAB.PAGES.DEMANDS.CREATION.@QUALIFICATIONS_MORE')"
          flat
          no-caps
          :loading="loading"
          @click.once="showAllQualifications()"
        />
      </section>
    </div>
  </div>
</template>

<script>
  import { NotificationsManager } from "@core/managers/notifications.manager";
  import { CreationStepQualificationFamilyModel, CreationStepQualificationModel, ICreationStepQualification } from "@core/models";

  export default {
    props: {
      stepData: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: false,
      },
      stepAssets: {
        type: Object,
        default: () => ({}),
      },
    },
    emits: ["saveStep"],
    data() {
      return {
        showAll: false,
        qualifications: [],
        familyId: undefined,
        qualificationId: undefined,
      };
    },
    computed: {
      stepDataModel() {
        return new CreationStepQualificationModel(this.stepData);
      },
      families() {
        const { families } = this.stepAssets;
        return families.map((family) => new CreationStepQualificationFamilyModel(family));
      },
      familiesOptions() {
        const options = [];
        this.families.forEach((family) => options.push(family.getSelectOptions()));
        return options;
      },
      hiddenQualifications() {
        return this.qualifications.filter((qualification) => !qualification.isFavorite());
      },
    },
    created() {
      this.qualificationId = this.stepDataModel[ICreationStepQualification.qualificationId];
      if (this.qualificationId) {
        this.init();
      }
    },
    methods: {
      isActive(qualification) {
        return this.qualificationId === qualification.getId();
      },
      showAllQualifications() {
        this.showAll = true;
      },
      selectQualification(qualification) {
        this.qualificationId = qualification.getId();
        this.save();
      },
      init() {
        // retrieve familyId based on qualification id
        this.families.forEach((family) => {
          const foundQualification = family.getQualifications().find((qualification) => qualification.getId() === this.qualificationId);
          if (foundQualification) {
            this.familyId = family.getId();
          }
        });
        this.setQualifications();
      },
      setQualifications() {
        let chosenFamily = null;
        if (this.familyId) {
          // user clicked
          chosenFamily = this.families.find((family) => this.familyId === family.getId());
        }
        const qualifications = chosenFamily ? chosenFamily.getQualifications() : [];
        // sort the array by favorites
        qualifications.sort((a, b) => b.isFavorite() - a.isFavorite());
        // if there's a selected item
        if (this.qualificationId) {
          // save the item
          const selectedQualificationId = qualifications.find((q) => q.getId() === this.qualificationId);
          if (selectedQualificationId) {
            // get the index and remove it from array
            const index = qualifications.findIndex((q) => q.getId() === this.qualificationId);
            qualifications.splice(index, 1);
            // put it back on front
            qualifications.unshift(selectedQualificationId);
          }
        }
        this.qualifications = qualifications;
      },
      save() {
        if (this.familyId && this.qualificationId) {
          this.$emit("saveStep", {
            [ICreationStepQualification.qualificationId]: this.qualificationId,
          });
        } else {
          NotificationsManager.error({ message: "ERRORS.@PLEASE_TRY_AGAIN" });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .creation-family-qualification {
    .step-title {
      margin-bottom: 0;
    }

    > section {
      margin-top: 20px;
    }
  }
</style>
